"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("../api/WickedApiClient");
var environment_1 = require("../../environments/environment");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var CaptchaService = /** @class */ (function () {
    function CaptchaService(captchaClient) {
        this.captchaKey = "";
        this.captchaClient = captchaClient;
        this.obtainCaptchaSiteKeyFromServer();
    }
    CaptchaService.prototype.getCurrentCaptchaKey = function () {
        return this.captchaKey;
    };
    CaptchaService.prototype.obtainCaptchaSiteKeyFromServer = function () {
        var _this = this;
        this.captchaClient.getCaptchaKey().subscribe(function (result) {
            console.log('enviroment', environment_1.environment.name);
            if (environment_1.environment.name != "CORDOVA") {
                _this.captchaKey = result;
            }
        });
    };
    CaptchaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CaptchaService_Factory() { return new CaptchaService(i0.ɵɵinject(i1.CaptchaClient)); }, token: CaptchaService, providedIn: "root" });
    return CaptchaService;
}());
exports.CaptchaService = CaptchaService;
